import { render, staticRenderFns } from "./ChangeTermModuleSlidebar.vue?vue&type=template&id=c3060a28"
import script from "./ChangeTermModuleSlidebar.vue?vue&type=script&lang=js"
export * from "./ChangeTermModuleSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports